<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="90%"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">

            <Row>
                <Col span="24">
                    <div class="em-list-header">
                        <div class="em-list-header-search">
                            <Select size="small" v-model="search.status" clearable placeholder="状态" class="search-select">
                                <Option :value="1">审核中</Option>
                                <Option :value="2">已驳回</Option>
                                <Option :value="3">已开票</Option>
                            </Select>
                            &nbsp;&nbsp;
                            <DatePicker size="small" v-model="search.time" clearable type="daterange" format="yyyy-MM-dd"  placeholder="申请日期" />
                            &nbsp;&nbsp;
                            <ButtonGroup >
                                <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                <Button size="small" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                            </ButtonGroup>
                        </div>
                    </div>
                    <Row :gutter="16"  style="margin-bottom: 20px">
                        <Col span="6">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        ￥{{staticData.total ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">开票总额</div>
                                <Icon type="ios-cafe" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="6">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-success">
                                        ￥{{staticData.total_3 ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">已开票</div>
                                <Icon type="ios-photos" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="6">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-orange">
                                        ￥{{staticData.total_1 ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">审核中</div>
                                <Icon type="ios-cafe" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="6">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-danger">
                                        ￥{{staticData.total_2 ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">已驳回</div>
                                <Icon type="md-contacts" size="26" class="icons" />
                            </div>
                        </Col>
                    </Row>

                    <Table :stripe="true" border  size="small" :loading="$store.state.loading" :columns="columns" :data="dataList.data" class="tables-x"  ref="selection"  no-data-text="暂无数据记录">
                        <template #inv_money="{ row }">
                            <div class="d-width" :title="row.inv_money">
                                <span>{{row.inv_money}}</span>
                            </div>
                        </template>
                        <template #get_money="{ row }">
                            <span>{{row.get_money??'0.00'}}</span>
                        </template>
                        <template #get_bank="{ row }">
                            <div class="d-width" :title="row.get_bank_name">
                                <span>{{row.get_bank_name??'-'}}</span>
                            </div>
                        </template>
                        <template #get_date="{ row }">
                            <div class="d-width" :title="row.get_date">
                                <span>{{row.get_date??'-'}}</span>
                            </div>
                        </template>
                        <template #inv_type="{ row }">
                            <Tag>{{row.inv_type_name}}</Tag>
                        </template>
                        <template #inv_head="{ row }">
                            <div class="d-width" :title="row.inv_head">
                                <span>{{row.inv_head}}</span>
                            </div>
                        </template>
                        <template #inv_num="{ row }">
                            <div class="d-width" :title="row.inv_num">
                                <span>{{row.inv_num}}</span>
                            </div>
                        </template>
                        <template #inv_bank="{ row }">
                            <div class="d-width" :title="row.inv_bank">
                                <span>{{row.inv_bank}}</span>
                            </div>
                        </template>
                        <template #inv_address="{ row }">
                            <div class="d-width" :title="row.inv_address">
                                <span>{{row.inv_address}}</span>
                            </div>
                        </template>
                        <template #status="{ row }">
                            <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                            <Poptip v-else-if="row.status === 2" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                <Badge color="red" :text="row.status_name" />
                                <template #content>
                                    <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                    <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                </template>
                            </Poptip>
                            <Badge v-else-if="row.status === 3" color="green" :text="row.status_name" />
                            <Badge v-else color="#999999" text="其他" />
                        </template>
                        <template #remark="{ row }">
                            <div class="d-width" :title="row.remark">
                                <span>{{row.remark}}</span>
                            </div>
                        </template>
                        <template #action="{ row }">
                            <a class="text-font-sm text-success" @click="showInvoiceData(row.inv_id)">查看</a>
                        </template>
                    </Table>
                    <div class="em-page em-flex">
                        <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                    </div>


                </Col>
            </Row>
        </div>

        <!-- 发票详情  -->
        <show-invoice-modal v-if="is_invoice_show" ref="ShowInvoiceRef"></show-invoice-modal>

    </Drawer>
</template>

<script>

import {getInvoiceList, getInvoiceStatic} from "@/apis/invoice";
import ShowInvoiceModal from "@/view/invoice/Show";

export default {
    name: 'InvoiceMoney',
    components: {
        ShowInvoiceModal
    },
    data () {
        return {
            statusList: [],
            search: {
                time: [],
                status: ''
            },
            page : 1,
            pageSize : 10,
            dataList : [],

            title: '发票记录',
            project_id: 0,
            staticData: [],
            detail: [],
            isBox: false,
            is_invoice_show: false,
            columns:[
                {
                    title: '发票类型',
                    key: 'inv_type',
                    slot: 'inv_type'
                },
                {
                    title: '开票金额',
                    key: 'inv_money',
                    slot: 'inv_money',
                },
                {
                    title: '到账金额',
                    key: 'get_money',
                    slot: 'get_money',
                },
                {
                    title: '到账银行',
                    key: 'get_bank',
                    slot: 'get_bank',
                },
                {
                    title: '到账时间',
                    key: 'get_date',
                    slot: 'get_date',
                },

                {
                    title: '发票抬头',
                    key: 'inv_head',
                    slot: 'inv_head',
                },
                {
                    title: '发票税号',
                    key: 'inv_num',
                    slot: 'inv_num',
                },
                {
                    title: '发票银行',
                    key: 'inv_bank',
                    slot: 'inv_bank',
                },
                {
                    title: '发票地址',
                    key: 'inv_address',
                    slot: 'inv_address',
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark',
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    // fixed : 'right',
                    width : 70
                }
            ]

        }
    },
    methods: {
        /**
         功能：
         time: 2026/1/6 15:48
         **/
        showInvoiceData(inv_id){
            let that = this;
            that.is_invoice_show = true;
            setTimeout(function(){
                that.$refs.ShowInvoiceRef.show(inv_id);
            })
        },
        onSearch(){
            let that = this;
            that.page = 1;
            that.getStaticData();
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                status: '',
                time: []
            };
            that.getStaticData();
            that.getList();
        },
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        getStaticData(){
            let that = this;
            if(!!that.project_id && that.project_id !== ''){
                const params = {
                    project_id : that.project_id,
                    search : that.search
                };
                getInvoiceStatic(params).then(e => {
                    that.staticData = e.data;
                    that.title = e.data.name + " - 发票记录";
                })
            }
        },
        getList(){
            let that = this;
            if(!!that.project_id && that.project_id !== ''){
                const params = {
                    pageSize : that.pageSize,
                    page : that.page,
                    project_id : that.project_id,
                    search : that.search
                };
                that.$store.commit('SET_LOADING' , true);
                getInvoiceList(params).then(e => {
                    that.dataList = e.data;
                })
            }
        },
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        show(project_id){
            this.isBox = true;
            if(project_id){
                this.project_id = project_id;
                this.getStaticData();
                this.getList();
            }
        },
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        FormReset(){
            this.isBox = false;
            this.title = '发票记录';
            this.search =  {
                time: [],
                status: ''
            };
            this.page = 1;
            this.project_id = 0;
            this.dataList = [];
            this.staticData = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.em-list-header {
    border-bottom: none;
}
.rx-index-box {
    width: 100%;
    position: relative;
    border: 1px solid #f6f6f6;
    background: #f6f6f6;
    border-radius: 5px;
    padding: 25px 10px;
    position: relative;
    box-shadow: 5px 5px 10px #EEE;
    cursor: pointer;
    transition: all 0.2s ease-in-out 0s;
    &:hover {
        background: #f2f2f2;
        box-shadow: 5px 5px 10px #ccc;
        transition: all 0.2s ease-in-out 0s;
    }
    .name {
        width: 100%;
        font-size: 15px;
        //font-weight: bold;
    }
    .box-line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 15px;
        .order-count {
            font-size: 20px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .order-count-small {
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            em {
                font-size: 16px;
                padding-left: 10px;
            }
        }
    }
    .icons {
        position: absolute;
        bottom: 10px;
        right: 10px;
        color: rgba(40,130,255,0.1);
    }
}
.rx-index-card {
    margin-top: 20px;
}
</style>
